import {observer} from "mobx-react";
import {useStore} from "../../stores/Store";
import {Alert, Box, Button, FormControl, Paper, Snackbar, Stack, TextField, Typography} from "@mui/material";
import React from "react";
import axios, {AxiosError, HttpStatusCode} from "axios";

const USERNAME: string = 'username';
const PASSWORD: string = 'password';

export default observer(function LoginForm() {
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
    const showErrorMessage = !!errorMessage;
    const {UserStore} = useStore();

    const handleErrorMessageClosed = (event?: React.SyntheticEvent | Event, reason?: string) => {
        setErrorMessage(null);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
        event.preventDefault();

        const formData = new FormData(event.currentTarget);
        const creds = {
            userName: formData.get(USERNAME) as string,
            password: formData.get(PASSWORD) as string,
        }

        try {
            await UserStore.login(creds);
        } catch (error) {
            if (error instanceof axios.AxiosError && (error as AxiosError).response?.status === HttpStatusCode.Unauthorized) {
                setErrorMessage('Invalid username or password!');
                return;
            }
            throw error;
        }
    }
    
    return (
        <>
            <Snackbar open={showErrorMessage} onClose={handleErrorMessageClosed}>
                <Alert onClose={handleErrorMessageClosed} severity="error" sx={{width: '100%'}}>
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="80vh"
            >

                <Box maxWidth={400} width="100%" p={3}>
                    <Paper sx={{p: 2}}>
                        <Stack>
                            <Typography variant="h5" align="center" sx={{p: 2}}>
                                Login
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <FormControl fullWidth>
                                    <TextField
                                        name={USERNAME}
                                        label="Username"
                                        variant="outlined"
                                        disabled={UserStore.isLoading}
                                        fullWidth
                                        required
                                        sx={{mb: 2}}
                                    />
                                    <TextField
                                        name={PASSWORD}
                                        label="Password"
                                        variant="outlined"
                                        type="password"
                                        fullWidth
                                        required
                                        sx={{mb: 2}}
                                    />
                                    <Box
                                        display={'flex'}
                                        alignItems={'center'}
                                        justifyContent={'center'}
                                        sx={{mt: 5, mb: 2}}
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            disabled={UserStore.isLoading}
                                        >
                                            Login
                                        </Button>
                                    </Box>
                                </FormControl>
                            </form>
                        </Stack>
                    </Paper>
                </Box>
            </Box>
        </>
    );
})